import React from "react";
import L from "leaflet";
import { CircleMarker } from "react-leaflet";
import RouteMapPoint from "../RouteMapPoint";
import {createMapKey} from "../../utils";

const RouteMapPointWrapper = props => {
  const { visitedRoutePoint, showPopup, showDelay } = props;

  /** @type {RouteResponsePoint} */
  const routePoint = visitedRoutePoint.routePoint; 
  const city = routePoint.city;
  const marker = React.createRef();
  const key = createMapKey(routePoint);
  const commonMarker = <RouteMapPoint visitedRoutePoint={visitedRoutePoint} key={key} showPopup={showPopup} markerRef={marker} showDelay={showDelay} />;
  const clickMarker = e => {
    e.originalEvent.preventDefault();
    marker.current.leafletElement.openPopup();
  };

  const phoneMarker = (
    <CircleMarker
      center={L.latLng(routePoint.geoPoint.lat, routePoint.geoPoint.lon)}
      stroke={false}
      fillOpacity={0}
      radius={14}
      onClick={clickMarker}
      pane="tooltipPane"
    >
      {commonMarker}
    </CircleMarker>
  );

  const citySize = city ? city.size : 1;
  const isPhoneMarker = L.Browser.mobile && citySize < 2;
  return isPhoneMarker ? phoneMarker : commonMarker;
};

export default RouteMapPointWrapper;
